import { faChevronCircleUp } from "@fortawesome/pro-duotone-svg-icons";
import { faChevronCircleDown } from "@fortawesome/pro-solid-svg-icons";
import { Icon } from "@growtherapy/sprout-ui";

export function PopoverChevronIndicator({ isOpen }: { isOpen?: boolean }) {
  return (
    <Icon
      data-testid="popover-button.chevron-icon"
      className="absolute -top-1 -right-1 bg-neutral-100 text-neutral-800 rounded-full"
      icon={isOpen ? faChevronCircleUp : faChevronCircleDown}
    />
  );
}
